/** @module modules/loans/models/microloan */

import Model from '~/libs/forms/model'
import recipes from '~/modules/loans/recipes/microloan'

/**
 * Attach field recipes to the model instance.
 * @internal
 * @ignore
 * @kind {Function}
 * @param {LoanModel} model
 * @param {Object} model.dictionaries
 * @param {Object[]} model.dictionaries.activities - Collection of loan activities.
 * @param {Object[]} model.dictionaries.currencies - Collection of currencies available for a loan
 *                                                   in this MFI.
 * @param {Object[]} model.dictionaries.types - Collection of loan types.
 */
const defineFields = function (model) {
  model.defineField('loanId', recipes.loanId())
  model.defineField('amount', recipes.amount())
}

export default class LoanModel extends Model {
  constructor (data = {}) {
    super(data)

    defineFields(this)

    this.populate(data)
    this.commit()
  }
}
